export const categories = [
  {
    slug: 'ziyuan-daohang',
    name: '资源导航',
    description: '精选火影同人漫画平台与资源站点汇总，一站式导航入口',
    icon: 'ri-compass-3-line',
    count: 28,
    color: 'accent',
  },
  {
    slug: 'chuangzuo-jiqiao',
    name: '创作技巧',
    description: '从分镜到上色，火影同人绘师必备的创作技法与经验分享',
    icon: 'ri-brush-line',
    count: 35,
    color: 'primary',
  },
  {
    slug: 'huishi-tuijian',
    name: '绘师推荐',
    description: '国内外优秀火影同人绘师作品赏析与个人主页导航',
    icon: 'ri-user-star-line',
    count: 42,
    color: 'secondary',
  },
  {
    slug: 'tongren-wenhua',
    name: '同人文化',
    description: '火影同人圈的文化脉络、展会资讯与社区动态解读',
    icon: 'ri-global-line',
    count: 19,
    color: 'accent',
  },
  {
    slug: 'shendu-jiexi',
    name: '深度解析',
    description: '火影角色关系、剧情走向的成人向同人深度解读与评析',
    icon: 'ri-file-search-line',
    count: 24,
    color: 'primary',
  },
  {
    slug: 'shequ-zixun',
    name: '社区资讯',
    description: '国内外同人展会、线上活动、新刊发布等最新动态',
    icon: 'ri-newspaper-line',
    count: 31,
    color: 'secondary',
  },
];

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  color: 'primary' | 'accent' | 'secondary';
}